var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [_c("CreateHistoryTask")], 1),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c("table", { staticClass: "table table-hover table-sm" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.records, function (r, i) {
                    return _c("tr", [
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            i +
                              1 +
                              (_vm.paginator.current_page - 1) *
                                _vm.paginator.per_page
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(r.title))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.printRegistration(r)))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("Search", {
                            ref: "search",
                            refInFor: true,
                            attrs: {
                              customPreset: { placeholder: "Поиск препарата" },
                              searchType: "003_drugs",
                              onSelect: (record) => _vm.addDrug(r.id, record),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(_vm.relatedDrugs[r.id], function (d, index) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-content-between mt-1 border-bottom",
                                },
                                [
                                  _c("div", [
                                    _c("p", [_vm._v(_vm._s(d.title))]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-muted" }, [
                                      _vm._v(_vm._s(d.group)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-default",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeRelatedDrug(
                                            r.id,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-trash-o",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("LoadingButton", {
                            attrs: {
                              title: "Сохранить",
                              loading: _vm.btnLoading[r.id],
                              color: _vm.$constants.SUCCESS_COLOR,
                              onClick: () => _vm.updateRelation(r.id),
                              className: "btn btn-outline-success",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Таблица связей препаратов (003ms)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Регистрация")]),
        _vm._v(" "),
        _c("th", { staticClass: "w-50" }, [_vm._v("Связь")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }